// extracted by mini-css-extract-plugin
export default {"container":"NvBecomeAVolunteer_container__z4VgH","infoSection":"NvBecomeAVolunteer_infoSection__xnxY7"};